import { getPayfitRedirectUri } from '../utils/get-environment';

export const PAYFIT_CLIENT_ID = process.env.REACT_APP_PAYFIT_USER_ID;
export const PAYFIT_CLIENT_SECRET = process.env.REACT_APP_PAYFIT_CLIENT_SECRET;
export const PAYFIT_GRANT_TYPE = 'authorization_code';
export const PAYFIT_REDIRECT_URI = getPayfitRedirectUri();
export const PAYFIT_SCOPES = 'collaborators:read collaborators:contracts:read';
export const PAYFIT_STATE = '1234567890';

// Template file path
export const PAYFIT_TEMPLATE_FILE_PATH = '/files/retribucion_especie_plantilla.xlsx';

// Payroll name constant
export const PAYFIT_PAYROLL_NAME = 'Plan de jubilación';

// Payfit file headers (8 columns)
export const PAYFIT_FILE_HEADERS = [
	'Identificador (no modificar)',
	'Empleado',
	'NIF o NIE',
	'Activar empleado',
	'Tipo',
	'Importe mensual',
	'Importe mensual pagado por empresa',
	'Nombre en nómina'
];

export const getPayfitAuthUrl = () => {
	return `https://oauth.payfit.com/authorize?redirect_uri=${PAYFIT_REDIRECT_URI}&client_id=${PAYFIT_CLIENT_ID}&response_type=code&scope=${PAYFIT_SCOPES}&state=${PAYFIT_STATE}`;
};
